<script lang="ts" setup>
import { useUserQuickComments } from "~/stores/useUserQuickComments";

const { categorizeQuickComments } = useUserQuickComments();

const props = defineProps({
  data: { type: Object as PropType<QuickComments>, required: true },
  hasCategories: { type: Boolean, default: false },
  placeholder: {
    type: String,
  },
});

const emits = defineEmits(["onSelected", "onMultiSelected", "onInsertText"]);

const onOptionClicked = (event: any) => {
  onSelected(event, true);
};

const onSelected = (event: any, includeLineBreak: boolean = false) => {
  const selectedCommentId = event;
  const selectedComment = props.data.find((c) => c.id == selectedCommentId);

  if (!selectedComment) return;

  emits("onInsertText", selectedComment.comment, includeLineBreak);
};

const options = computed(() => {
  const cOptions = {} as { [key: string]: QuickComment[] };

  for (const categoryComments of categorizeQuickComments(props.data)) {
    cOptions[categoryComments.category] = categoryComments.quickComments;
  }

  return cOptions;
});
</script>

<template>
  <div>
    <BaseSelectInput
      :options="[]"
      :grouped-options="options"
      :block-outside-focus="true"
      label="comment"
      value-prop="id"
      :are-options-grouped="true"
      :placeholder="placeholder"
      side="top"
      @update:model-value="onSelected"
      @option-clicked="onOptionClicked"
    />
  </div>
</template>

<style scoped></style>
